import React from "react";
import { Shell } from "@/components/loomi/Layout";
import { PM_NAV } from "./PmDashboard";
import TwoFactorPanel from "@/components/loomi/TwoFactorPanel";

export default function PmSettings() {
  return (
    <Shell title="Settings" portalLabel="PM" nav={PM_NAV}>
      <TwoFactorPanel testId="pm-twofa-panel" />
    </Shell>
  );
}
